module.exports = __webpack_public_path__ + "static/media/blackboard.69d9fe51.png";